export const METRIC_ACCURACY = "ACCURACY";
export const METRIC_NO_SHOW = "NO_SHOW";
export const METRIC_WORKSTATION = "WORKSTATION";
export const METRIC_EFFICIENCY = "EFFICIENCY";

export const METRIC_UTILISATION_UTILISATION = "UTILISATION_UTILISATION";
export const METRIC_UTILISATION_BOOKED = "UTILISATION_BOOKED";
export const METRIC_UTILISATION_NO_SHOW = "UTILISATION_NO_SHOW";
export const METRIC_UTILISATION_GHOST = "UTILISATION_GHOST";